import Footer from "./components/Footer";
import Header from "./components/Header";

export default function TermsAndConditions() {
  return (
    <>
    <Header />
    <section className="mx-auto max-w-4xl px-4 py-10">
      <h1 className="text-4xl font-bold text-[#022850] mb-6">Terms &amp; Conditions</h1>

      <p className="text-[#757279] mb-4">
        Welcome to Online German Skool, a division of The Language Skool (TLS). By accessing or
        using our website [www.onlinegermanskool.com], enrolling in a course, or participating in
        any of our programs, you agree to abide by the following Terms and Conditions. If you do not
        agree to these Terms, please refrain from using our website or services.
      </p>

      <ol className="space-y-6 list-decimal pl-6">
        <li>
          <h2 className="text-2xl font-semibold text-[#022850] mb-2">Use of Services</h2>
          <div className="text-[#757279] space-y-2">
            <p>By using the Online German Skool website, you acknowledge and agree to comply with all rules and policies set forth herein. Our services include:</p>
            <ul className="list-disc pl-6">
              <li>Booking demo classes</li>
              <li>Enrolling in German language courses</li>
              <li>Accessing online study materials, dashboards, and recorded sessions after registration</li>
            </ul>
            <p>All services provided by Online German Skool are governed by the operational policies of The Language Skool (TLS).</p>
          </div>
        </li>

        <li>
          <h2 className="text-2xl font-semibold text-[#022850] mb-2">User Accounts</h2>
          <div className="text-[#757279] space-y-2">
            <p>Users are required to create an account to book demo sessions or enroll in any course.</p>
            <p>You must provide accurate, complete, and up-to-date information during registration.</p>
            <p>You are solely responsible for maintaining the confidentiality of your login credentials and for any activities that occur under your account.</p>
            <p>Online German Skool will not be liable for any loss or damage arising from unauthorised access to your account.</p>
          </div>
        </li>

        <li>
          <h2 className="text-2xl font-semibold text-[#022850] mb-2">Class Attendance</h2>
          <div className="text-[#757279] space-y-2">
            <p>Students are expected to attend all classes regularly and on time.</p>
            <p>Missing three consecutive sessions without prior notice to Online German Skool or TLS may lead to automatic cancellation of admission.</p>
            <p>Consistent absenteeism may also result in being removed from live batches.</p>
          </div>
        </li>

        <li>
          <h2 className="text-2xl font-semibold text-[#022850] mb-2">Microphone and Camera Usage</h2>
          <div className="text-[#757279] space-y-2">
            <p>Microphones should remain muted unless the trainer invites you to speak. Use the raise-hand feature to ask questions during class.</p>
            <p>Cameras must remain on throughout the class to ensure active engagement and participation. Failure to comply may result in removal from the live session.</p>
          </div>
        </li>

        <li>
          <h2 className="text-2xl font-semibold text-[#022850] mb-2">Conduct and Confidentiality</h2>
          <div className="text-[#757279] space-y-2">
            <p>All students are expected to maintain a respectful, disciplined, and professional learning environment. Please adhere to the following:</p>
            <ul className="list-disc pl-6">
              <li>Keep course content, discussions, and materials strictly confidential.</li>
              <li>Dress appropriately and participate from a quiet, distraction-free environment.</li>
              <li>Do not contact trainers or staff on personal messaging platforms (e.g., WhatsApp, Instagram, or Facebook). Violations may lead to disciplinary action or legal consequences.</li>
              <li>Do not discuss or disclose fee details with other students. Breach of this rule may result in payment adjustments to match standard course pricing.</li>
            </ul>
          </div>
        </li>

        <li>
          <h2 className="text-2xl font-semibold text-[#022850] mb-2">Breaks and Absences</h2>
          <div className="text-[#757279] space-y-2">
            <p>Inform the management via email before taking a break or planned leave.</p>
            <p>Uninformed absences may lead to course suspension or admission cancellation.</p>
            <p>Rescheduling of classes due to absence is at the discretion of the management.</p>
          </div>
        </li>

        <li>
          <h2 className="text-2xl font-semibold text-[#022850] mb-2">Testimonials and Recordings</h2>
          <div className="text-[#757279] space-y-2">
            <p>Student testimonials or feedback may be shared on social media platforms for educational or promotional purposes.</p>
            <p>To access class recordings, students must maintain a minimum of 70% attendance. Exceptions may be granted for genuine, documented reasons.</p>
          </div>
        </li>

        <li>
          <h2 className="text-2xl font-semibold text-[#022850] mb-2">Technical Issues</h2>
          <div className="text-[#757279] space-y-2">
            <p>If you experience technical difficulties or issues accessing classes, contact the Online German Skool technical support team immediately.</p>
            <p>While we strive to ensure uninterrupted learning, Online German Skool and TLS are not liable for issues arising from poor internet connectivity or device malfunctions on the user’s end.</p>
          </div>
        </li>

        <li>
          <h2 className="text-2xl font-semibold text-[#022850] mb-2">One-on-One Sessions</h2>
          <div className="text-[#757279] space-y-2">
            <p>Students enrolled in one-on-one sessions must adhere to scheduled timings.</p>
            <p>Habitual lateness, early exits, or repeated irregularities may result in conversion of sessions to group classes at the same fee structure.</p>
          </div>
        </li>

        <li>
          <h2 className="text-2xl font-semibold text-[#022850] mb-2">Fees and Refund Policy</h2>
          <div className="text-[#757279] space-y-2">
            <p>All course fees paid to Online German Skool are non-refundable under any circumstances.</p>
            <p>Fees once paid cannot be transferred to another course, student, or batch.</p>
            <p>In exceptional cases (such as course cancellation by the institution), appropriate solutions or adjustments may be offered at the sole discretion of TLS management.</p>
          </div>
        </li>

        <li>
          <h2 className="text-2xl font-semibold text-[#022850] mb-2">Adherence to Guidelines</h2>
          <div className="text-[#757279] space-y-2">
            <p>Students are expected to comply with all academic and behavioural guidelines set by Online German Skool and The Language Skool (TLS).</p>
            <p>Any violation may result in warnings, suspension, or permanent termination of enrolment, depending on the severity of the case.</p>
          </div>
        </li>

        <li>
          <h2 className="text-2xl font-semibold text-[#022850] mb-2">Modifications to Terms</h2>
          <div className="text-[#757279] space-y-2">
            <p>
              Online German Skool, as a division of The Language Skool (TLS), reserves the right to modify, update, or revise these
              Terms and Conditions at any time without prior notice. Any changes will be posted on this page, and continued use of
              the website or services implies acceptance of the revised Terms.
            </p>
          </div>
        </li>
      </ol>
    </section>
    <Footer />
    </>
  );
}
